import { useEffect, useState } from 'react';

const SelectClass = ({
  setDisable,
  loading = false,
  classData = {},
  setClassData,
  courses,
  clearAttendance,
  loadingCourses = false,
  batchStructures,
  loadingBatches = false,
}) => {
  const [errors, setErrors] = useState([]);

  const safeCourses = Array.isArray(courses) ? courses : [];
  const safeBatches = Array.isArray(batchStructures) ? batchStructures : [];
  const safeErrors = Array.isArray(errors) ? errors : [];

  // =============================
  // Handlers
  // =============================
  const handleCourseChange = (e) => {
    const courseId = e.target.value;

    setClassData((prev) => ({
      ...prev,
      courseId,
      batchId: '',
    }));

    clearAttendance?.();
  };

  const handleBatchChange = (e) => {
    const batchId = e.target.value;

    setClassData((prev) => ({
      ...prev,
      batchId,
    }));
  };

  // =============================
  // Validation
  // =============================
  useEffect(() => {
    const nextErrors = [];

    if (!classData?.courseId) {
      nextErrors.push('Please select a course.');
    }

    if (!classData?.batchId) {
      nextErrors.push('Please select a batch.');
    }

    setErrors(nextErrors);
    setDisable(nextErrors.length > 0);
  }, [classData?.courseId, classData?.batchId, setDisable]);

  // =============================
  // UI
  // =============================
  return (
    <div className="w-full rounded-lg px-3 pt-7 md:px-8">
      <div className="flex justify-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Select Class Information
        </h4>
      </div>

      {loading && (
        <div className="mt-4 text-center">
          <span>Loading...</span>
        </div>
      )}

      {/* COURSE */}
      <div className="mt-6 flex flex-col md:items-center">
        <div className="w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Course
          </label>

          <select
            value={classData?.courseId || ''}
            onChange={handleCourseChange}
            disabled={loading}
            className="mt-2 w-full rounded-xl border border-gray-200 px-3 py-3 text-sm outline-none dark:bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Course</option>

            {loadingCourses && <option disabled>Loading courses...</option>}

            {!loadingCourses &&
              safeCourses.map((course, i) => (
                <option key={course._id} value={course._id}>
                  {i + 1}. {course.courseName}
                </option>
              ))}
          </select>
        </div>
      </div>

      {/* BATCH */}
      <div className="mt-6 flex flex-col md:items-center">
        <div className="w-full md:w-1/2">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Batch Structure
          </label>

          <select
            value={classData?.batchId || ''}
            onChange={handleBatchChange}
            disabled={!classData?.courseId || loadingBatches}
            className="mt-2 w-full rounded-xl border border-gray-200 px-3 py-3 text-sm outline-none dark:bg-navy-800 dark:text-white"
          >
            <option value="">
              {loadingBatches
                ? 'Loading batches...'
                : !classData?.courseId
                ? 'Select course first'
                : safeBatches.length === 0
                ? 'No batches available'
                : 'Click here to Select Batch'}
            </option>

            {safeBatches.map((batch, index) => (
              <option key={batch._id} value={batch._id}>
                {index + 1}. {batch.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* ERRORS */}
      {safeErrors.length > 0 && (
        <div className="mt-4 text-center text-red-500">
          {safeErrors.map((err, i) => (
            <div key={i}>{err}</div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectClass;
